import { Routes, Route } from 'react-router-dom'
import { AppProvider } from '@!/providers'
import { usePaymentSettings } from '@!/Hooks'
import Restore from '@!/User/Payment/containers/MonthlyCourse/Restore'
import NewCard from '@!/User/Payment/containers/MonthlyCourse/NewCard'
import RestoreConfirm from '@!/User/Payment/containers/MonthlyCourse/RestoreConfirm'
import PaymentRedirect from '@!/User/Payment/containers/PaymentRedirect'

const RestoreApp = (props) => {
  const jotaiStore = usePaymentSettings({
    isSaveLastUrl: false,
    tokenApiUrl: props.token_api_url,
    shopId: props.shop_id,
    monthlyCourses: props.monthly_courses,
  })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Routes>
        <Route path="/" element={<Restore monthlyCourseHistory={props.monthly_course_history} />} />
        <Route path="/new_card" element={<NewCard />} />
        <Route path="/confirm" element={<RestoreConfirm />} />
        <Route path="/redirect" element={<PaymentRedirect />} />
      </Routes>
    </AppProvider>
  )
}

export default RestoreApp
